import { DAYS } from "../util/constants";

export const convertEpochtoDate = (epoch: any, type?: string) => {
  const date = new Date(epoch * 1000);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  if (type === "getDateValue") return `${year}-${month}-${day}`;
  return `${day}-${month}-${year}`;
};

export const convertUTCEpochToDate = (epoch: any, type?: string) => {
  const date = new Date(epoch * 1000);
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();
  if (type === "getDateValue") return `${year}-${month}-${day}`;
  return `${day}-${month}-${year}`;
};

export const convertEpochToTime = (epoch: number) => {
  return new Date(epoch * 1000).toLocaleString().split(",")[1];
};

export const convertEpochToTimeUTC = (epoch: number) => {
  const date = new Date(epoch * 1000);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  return `${hours}:${minutes}:00 ${ampm}`;
  // return new Date(epoch * 1000).toLocaleString().split(",")[1];
};

export const convertEpochToDateTime = (epoch: any, type?: string) => {
  const date = new Date(epoch * 1000);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  // const seconds = date.getSeconds().toString().padStart(2, "0");

  if (type === "getDateValue") return `${year}-${month}-${day}T${hours}:${minutes}`;
  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

export const fetchDayFromEpochDate = (epoch: any, type?: string) => {
  const date = new Date(epoch * 1000);

  return DAYS[date.getDay()];
};

export const convertDateToEpoch = (date: any) => {
  return Math.floor(date.getTime() / 1000.0);
};

export const convertDateToEpochUTC = (date: any) => {
  // Offset in minutes; multiply by 60 to get seconds
  const offsetSeconds = new Date().getTimezoneOffset() * 60;

  // const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  return Math.floor(date.getTime() / 1000.0) - offsetSeconds;
};

export const convertLocalToUTC = (date: any) => {
  // Offset in minutes; multiply by 60 to get seconds
  const offsetSeconds = new Date().getTimezoneOffset() * 60;
  return date - offsetSeconds;
}

export const computeGroupedTimes = (data: any[], groupBy: string) => {
  const groupedData: {
    [key: string]: { totalAppTime: number; totalManagerTime: number; totalTrackerTime: number };
  } = {};

  data.forEach((log) => {
    const groupKey = log[groupBy];
    if (!groupedData[groupKey]) {
      groupedData[groupKey] = { totalAppTime: 0, totalManagerTime: 0, totalTrackerTime: 0 };
    }

    // Convert duration to seconds and add
    groupedData[groupKey].totalAppTime += convertTimeToSeconds(log.duration);
    groupedData[groupKey].totalManagerTime += convertTimeToSeconds(log.manager_duration);
    groupedData[groupKey].totalTrackerTime += convertTimeToSeconds(
      log.tracker_duration
    );
  });

  return groupedData;
};

// Utility function to convert HH:MM:SS to seconds
export const convertTimeToSeconds = (timeString: string) => {
  if (!timeString) return 0;
  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};

// Utility function to convert seconds back to HH:MM:SS
export const convertSecondsToTime = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  // const seconds = totalSeconds % 60;
  // return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
};

export const removeSecFromDuration = (duration: string) => {
  return duration ? duration.slice(0, 5) : null;
};


